// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-19c24eca] .v-btn::before {\n  background-color: transparent;\n}\n[data-v-19c24eca] .v-tabs-items {\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
